import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { MachineContext } from '../ResolutionFlow.machine.types'

export async function getOrderlineTimeline({ orderlineId }: MachineContext) {
  const $httpFetch = useHttpFetch()
  const payload = await $httpFetch(
    '/my-orders/orderlines/:orderlineId/timeline',
    {
      pathParams: {
        orderlineId: String(orderlineId),
      },
    },
  )

  return payload
}
